import { defineEntityOwner } from './types';

export const teamOwnerDescriptor = defineEntityOwner('team', {
  owningService: 'capacity',
  clientPackage: '@tempo-io/backend-capacity-client',
  cdcTopic: 'capacity-data-changes',
  resolveLink: (entityId, ctx) => `/org-id/${ctx.organizationId}/settings/teams/team/${entityId}`,
  resolveLabels: null,
});
